import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {TranslateModule} from "@ngx-translate/core";
import {MenuTrackerRetailPage} from './menu-tracker-retail';
import {ReaderService} from "../../providers/reader.service";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    MenuTrackerRetailPage,
  ],
  imports: [
    HeaderTitleComponentModule,
    IonicPageModule.forChild(MenuTrackerRetailPage),
    TranslateModule.forChild()
  ],
  providers: [
    ReaderService
  ]
})
export class MenuTrackerRetailPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/menu-tracker-retail/menu-tracker-retail.module.ts